"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtlasHashResponseToJSON = exports.AtlasHashResponseFromJSONTyped = exports.AtlasHashResponseFromJSON = void 0;
function AtlasHashResponseFromJSON(json) {
    return AtlasHashResponseFromJSONTyped(json, false);
}
exports.AtlasHashResponseFromJSON = AtlasHashResponseFromJSON;
function AtlasHashResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'name': json['name'],
        'email': json['email'],
        'userHash': json['userHash'],
    };
}
exports.AtlasHashResponseFromJSONTyped = AtlasHashResponseFromJSONTyped;
function AtlasHashResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'name': value.name,
        'email': value.email,
        'userHash': value.userHash,
    };
}
exports.AtlasHashResponseToJSON = AtlasHashResponseToJSON;
